import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  Chip,
  Stack,
  IconButton,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  AssignmentInd as AssignIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

const orangeColor = "#FF7A2B";
const orangeHoverColor = "#F57C00";

const BakiciDetayModal = ({
  open,
  onClose,
  bakici,
  atananKumesler,
  onEdit,
  onDelete,
  onAssign,
  formatDate,
  getUlkeAdi,
  getEvlilikText,
}) => {
  if (!bakici) return null;

  // Bilgi satırı - çizgili
  const InfoRow = ({ label, value }) => (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            fontSize: "1.1rem",
            color: "text.primary",
          }}
        >
          {value || "-"}
        </Typography>
      </Box>
      <Divider />
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {/* Başlık */}
      <DialogTitle
        sx={{
          backgroundColor: orangeColor,
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>
          {bakici.BAKICI_ADI} {bakici.BAKICI_SOYADI}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* İçerik */}
      <DialogContent sx={{ pt: 3 }}>
        {/* Kişisel Bilgiler - Her biri çizgi ile ayrılmış */}
        <InfoRow label="TC Kimlik No" value={bakici.TCKN} />
        <InfoRow
          label="Telefon"
          value={bakici.KULLANICI_TEL_NO ?? "Numara Yok"}
        />
        <InfoRow label="Doğum Tarihi" value={formatDate(bakici.DOGUM_TARIHI)} />
        <InfoRow
          label="Doğum Yeri"
          value={
            bakici.IL_ADI && bakici.ILCE
              ? `${bakici.IL_ADI} / ${bakici.ILCE}`
              : bakici.IL_ADI || "-"
          }
        />
        <InfoRow label="Uyruk" value={getUlkeAdi(bakici.UYRUK_ULKE_ID)} />
        <InfoRow
          label="Medeni Durum"
          value={getEvlilikText(bakici.EVLIMI || bakici.EVLI_MI)}
        />
        <InfoRow label="Çocuk Sayısı" value={bakici.COCUK_SAYISI || "0"} />
        <InfoRow label="Eğitim Durumu" value={bakici.EGITIM_DURUMU_ADI} />

        <Divider sx={{ my: 3, borderWidth: 2 }} />

        {/* Atanan Kümesler */}
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: orangeColor,
              fontWeight: "bold",
              mb: 2,
            }}
          >
            ATANAN KÜMESLER ({atananKumesler?.length || 0})
          </Typography>
          {atananKumesler && atananKumesler.length > 0 ? (
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {atananKumesler.map((kumes) => (
                <Chip
                  key={kumes.KUMES_ID}
                  label={kumes.KUMES_ADI || "Kümes"}
                  sx={{
                    backgroundColor: orangeColor,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    py: 2,
                    px: 2,
                    mb: 1,
                  }}
                />
              ))}
            </Stack>
          ) : (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              Henüz kümes ataması yapılmamış
            </Typography>
          )}
        </Box>
      </DialogContent>

      {/* İşlem Butonları */}
      <DialogActions
        sx={{
          p: 2,
          gap: 1,
          justifyContent: "space-between",
          backgroundColor: "#fafafa",
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            fontSize: "1rem",
            py: 1,
            px: 2,
          }}
        >
          KAPAT
        </Button>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={onEdit}
            sx={{
              fontSize: "1rem",
              py: 1,
              px: 2,
            }}
          >
            DÜZENLE
          </Button>
          <Button
            variant="contained"
            startIcon={<AssignIcon />}
            onClick={onAssign}
            sx={{
              backgroundColor: orangeColor,
              "&:hover": { backgroundColor: orangeHoverColor },
              fontSize: "1rem",
              py: 1,
              px: 2,
            }}
          >
            KÜMES ATA
          </Button>
          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={onDelete}
            color="error"
            sx={{
              fontSize: "1rem",
              py: 1,
              px: 2,
            }}
          >
            SİL
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default BakiciDetayModal;
